import requests from "./httpService";

const ReviewServices = {

    getReview : async () =>{
        return requests.get(`/review`);
    },
    updateReview : async (id,body) =>{
        // console.log(body);
        return requests.patch(`/review/${id}`,body);
    },
    updateReviewStatus : async (id,body) =>{
        // console.log(body);
        return requests.patch(`/review/status/${id}`,body);
    },

    createReview : async (body) =>{
        // console.log(body)
        return requests.post(`/review`,body);
    },
    deleteReview : async (id) =>{
        return requests.delete(`/review/${id}`);
    }
    
   


}

export default ReviewServices;